/*
 *   Copyright (c) 2020 BuserNet Consulting LLC
 *   All rights reserved.
 */
import AboutUs from './views/AboutUs.vue';
import Airport from './views/Airport/Airport.vue';
import Preferences from './views/Preferences.vue';
import Weather from './views/Weather/Weather.vue';
import Developer from './views/Developer.vue';
import Routeprofile from './views/Routeprofile/Routeprofile.vue';
import Gridview from './views/Gridview/Gridview.vue';
import Imagery from './views/Imagery/Imagery.vue';
import Account from './views/Account.vue';
import Mapview from './views/Mapview/Mapview.vue';
import PersonalMinimums from './views/PersonalMinimums.vue';
import Login from './views/Login.vue';
import AuthSuccess from './views/AuthSuccess.vue';

const routes = [
  {
    path: '/app/aboutus',
    name: 'app.aboutus',
    component: AboutUs,
  },
  {
    path: '/app/dashboard',
    name: 'app.dashboard',
    component: Airport,
  },
  {
    path: '/app/personalminimums',
    name: 'app.personalminimums',
    component: PersonalMinimums,
  },
  {
    path: '/app/settings',
    name: 'app.settings',
    component: Preferences,
  },
  {
    path: '/auth/success',
    name: 'app.authSuccess',
    component: AuthSuccess,
  },
  {
    path: '/app/weather',
    name: 'app.weather',
    component: Weather,
  },
  {
    path: '/app/developer',
    name: 'app.developer',
    component: Developer,
  },
  {
    path: '/app/routeprofile',
    name: 'app.routeprofile',
    component: Routeprofile,
  },
  {
    path: '/app/gridview',
    name: 'app.gridview',
    component: Gridview,
  },
  {
    path: '/app/mapview',
    name: 'app.mapview',
    component: Mapview,
  },
  {
    path: '/app/account',
    name: 'app.account',
    component: Account,
  },
  {
    path: '/app/avwxtab',
    name: 'app.avwxtab',
    component: Imagery,
  },
  {
    path: '/app/imagery',
    name: 'app.imagery',
    component: Imagery,
  },
  {
    path: '/app/login',
    name: 'app.login',
    component: Login,
  },
];

export default routes;
